import React, { Component, Fragment } from 'react';
import {withRouter, Link} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import { numberFormat } from '../../common';

@withRouter
@inject('totoStore', 'dictStore')
@observer
export default class Cards extends Component{

  componentDidMount() {
    this.props.totoStore.Cards.init(this.props.match.params);
  }

  componentWillUnmount() {
    this.props.totoStore.Cards.dispose();
  }

  render() {
    const {isLoading, result, Cards} = this.props.totoStore;
    const {getLang} = this.props.dictStore;
    return(
      !isLoading ? 
        <div className="toto-index-loading">
          <LoadingSpinner />
        </div> :
      <Fragment>
        {Cards.data ? <TotoCards /> : <div className="toto-index-no">{getLang('INVALID_RESULT_ID')}</div>}
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore', 'appStore')
@observer
class TotoCards extends Component { 

  selectCurrency = (e) => {
    this.props.totoStore.selectCurrency(e.target.value)
  }

  selectPage = (page) => {
    this.props.totoStore.Cards.selectPage(page);
  }

	render() {

    const {getLang} = this.props.dictStore;
    const {currency, currencyId, current} = this.props.totoStore;
    const {data, vc, page, pages, count, cards, isLoading} = this.props.totoStore.Cards;
    const min = count*page + 1;
    const max = (page + 1) * count;
    const arrCurrency = data.currency ? Object.keys(data.currency) : [this.props.appStore.financeData[currencyId]];

		return(
			<div className="toto-cards">
        <div className="clearfix">
          <div className="fl_r">
            <label htmlFor="toto-currency">{getLang('SHOW_IN_CURRENCY')} </label>
            <select className="toto-index-currency" onChange={this.selectCurrency}>
              {data.currency ? 
                arrCurrency.map(id => 
                  <option key={id} value={data.currency[id].id} selected={data.currency[id].id == currencyId}>{data.currency[id].full_name}</option>
                ) : 
                arrCurrency.map(el => 
                  <option key={el.id} value={el.id} selected={el.id == currencyId}>{el.full_name}</option>
                ) 
              }
            </select>
          </div>
          <div className="toto-cards-back">
            <Link to={`/toto/result/${data.id}`}>{getLang('DETAILED_RESULTS_OF_DRAW')}</Link>
          </div>
        </div>
        <div>
            <div>{getLang("DRAW")} #R-{data.number}, {data.date.start} - {data.date.end}</div>
            {vc >= 9 ? 
              getLang('BETS_CONTAINING_OPTIONS_WITH_GUESSED_RESULTS_1') + vc + getLang('BETS_CONTAINING_OPTIONS_WITH_GUESSED_RESULTS_2') :
              getLang('BETS_CONTAINING_WINNING_OPTIONS')
            }
        </div>
        <div className="toto-cards-nav-cont clearfix">
          {pages.map(el => 
            <div key={`nav_${el.i}`}>
              <a className={`toto-cards-nav-page-a fl_l${page == el.i ? ' toto-cards-nav-page-a-selected' : ''}`} onClick={() => this.selectPage(el.i)}>{el.i + 1}</a>
            </div>
          )}
        </div>
        <div className="clearfix">
            <div className="fl_r">
                {getLang('BETS')} <span>{min}</span> - <span>{max > data.count ? data.count : max}</span>
            </div>
        </div>
        <div className="toto-cards-table-cont">
          <table className="toto-table">
              <thead>
                  <tr>
                      <th>{getLang('CARD')}</th>
                      <th>{getLang('AMOUNT')}</th>
                      <th>{getLang('OPTIONS')}</th>
                      <th>{getLang('AMOUNT_FOR_1_OPTION')}</th>
                      <th>{getLang('MAX_GUESSED')}</th>
                      <th>{getLang('PAYOUT')}</th>
                  </tr>
              </thead>
              <tbody>
                {isLoading ? 
                  <tr>
                    <td colspan="6" className="toto-cards-loading">{getLang('LOADING')}...</td>
                  </tr> :
                  Object.keys(cards[page]).map(i => 
                    <tr key={cards[page][i].id}>
                      <td className="toto-cards-table-number"><Link to={`/toto/bet/${cards[page][i].id}`}>{cards[page][i].code}</Link></td>
                      <td className="toto-cards-table-set">{numberFormat(cards[page][i].set[currencyId], 2, ',', ' ')} {current.name}</td>
                      <td className="toto-cards-table-option">{cards[page][i].option_count}</td>
                      <td className="toto-cards-table-option-set">{numberFormat(cards[page][i].set_per_bet[currencyId], 2, ',', ' ')} {current.name}</td>
                      <td className="toto-cards-table-option-guessed">{cards[page][i].guessed}</td>
                      <td className="toto-cards-table-win">{numberFormat(cards[page][i].win[currencyId], 2, ',', ' ')} {current.name}</td>
                    </tr>
                  )
                }
              </tbody>
          </table>
        </div>
      </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/toto/cards.jsx